"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _lodash = _interopRequireDefault(require("lodash"));

var _axios = _interopRequireDefault(require("axios"));

var _basic = _interopRequireDefault(require("./_basic"));

var _bluebird = _interopRequireDefault(require("bluebird"));

var SharedApi =
/*#__PURE__*/
function (_BasicApi) {
  (0, _inherits2.default)(SharedApi, _BasicApi);

  /**
   * @constructor
   */
  function SharedApi(_ref) {
    var _this;

    var userTokenFactory = _ref.userTokenFactory,
        sdkApiUrl = _ref.sdkApiUrl;
    (0, _classCallCheck2.default)(this, SharedApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SharedApi).call(this, {
      userTokenFactory: userTokenFactory
    }));
    _this.sdkApiUrl = sdkApiUrl;
    _this.usersUrl = "".concat(sdkApiUrl, "/users");
    _this.sharingUrl = "".concat(sdkApiUrl, "/shared");
    _this.publicSharingUrl = "".concat(sdkApiUrl, "/public/shared");
    return _this;
  }

  (0, _createClass2.default)(SharedApi, [{
    key: "getGuests",
    value: function () {
      var _getGuests = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(limit, last) {
        var _this2 = this;

        var headers, config;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context.sent;
                config = _lodash.default.merge({
                  params: {}
                }, headers);

                if (limit) {
                  config.params.limit = limit;
                }

                if (last) {
                  config.params.last = last;
                }

                return _context.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this2.usersUrl, "/shared"), config).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getGuests(_x, _x2) {
        return _getGuests.apply(this, arguments);
      }

      return getGuests;
    }()
  }, {
    key: "deleteShared",
    value: function () {
      var _deleteShared = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(userId, entityType, entityId) {
        var _this3 = this;

        var headers;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context2.sent;
                return _context2.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.delete("".concat(_this3.sharingUrl, "/").concat(userId, "/").concat(entityType, "/").concat(entityId), headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function deleteShared(_x3, _x4, _x5) {
        return _deleteShared.apply(this, arguments);
      }

      return deleteShared;
    }()
  }, {
    key: "addShared",
    value: function () {
      var _addShared = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(userId, entityType, entityId) {
        var _this4 = this;

        var headers;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context3.sent;
                return _context3.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.post("".concat(_this4.sharingUrl, "/").concat(userId, "/").concat(entityType, "/").concat(entityId), null, headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function addShared(_x6, _x7, _x8) {
        return _addShared.apply(this, arguments);
      }

      return addShared;
    }()
  }, {
    key: "addSharedMany",
    value: function () {
      var _addSharedMany = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(userId, entityType, entityIds) {
        var _this5 = this;

        var headers;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context4.sent;
                return _context4.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.post("".concat(_this5.sharingUrl, "/").concat(userId, "/").concat(entityType), {
                    ids: entityIds
                  }, headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function addSharedMany(_x9, _x10, _x11) {
        return _addSharedMany.apply(this, arguments);
      }

      return addSharedMany;
    }() //public sharing

  }, {
    key: "deletePublicShared",
    value: function () {
      var _deletePublicShared = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(entityType, entityId) {
        var _this6 = this;

        var headers;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context5.sent;
                return _context5.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.delete("".concat(_this6.publicSharingUrl, "/").concat(entityType, "/").concat(entityId), headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function deletePublicShared(_x12, _x13) {
        return _deletePublicShared.apply(this, arguments);
      }

      return deletePublicShared;
    }()
  }, {
    key: "addPublicShared",
    value: function () {
      var _addPublicShared = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(entityType, entityId) {
        var _this7 = this;

        var headers;
        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context6.sent;
                return _context6.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.post("".concat(_this7.publicSharingUrl, "/").concat(entityType, "/").concat(entityId), null, headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function addPublicShared(_x14, _x15) {
        return _addPublicShared.apply(this, arguments);
      }

      return addPublicShared;
    }()
  }, {
    key: "getPublicShared",
    value: function () {
      var _getPublicShared = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee7(entityType, entityId) {
        var _this8 = this;

        var headers;
        return _regenerator.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return this.getHeaders();

              case 2:
                headers = _context7.sent;
                return _context7.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get("".concat(_this8.publicSharingUrl, "/").concat(entityType, "/").concat(entityId), headers).then(function (response) {
                    return _bluebird.default.resolve(response.data);
                  });
                }));

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function getPublicShared(_x16, _x17) {
        return _getPublicShared.apply(this, arguments);
      }

      return getPublicShared;
    }()
  }]);
  return SharedApi;
}(_basic.default);

var _default = SharedApi;
exports.default = _default;